import React from 'react';
import './Reviews.css';
import Huzvarova from '../../img/review/Huzvarova.png'
import Lombard from '../../img/review/Lombard.png'
import Mughal from '../../img/review/Mughal.png'
import Tagle from '../../img/review/Tagle.png'

export default class Reviews extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      reviews: [
        {
            id: 1,
            photo: Lombard,
            name: 'Tristan Lombard',
            position: 'Test Automation Enthusiast I Customer Advocate I Community Builder',
            title: 'I was very impressed by how well you all organized the event and kept timing on track. Was super inspiring to see so many diverse leaders sharing knowledge, while global community learned and networked. I hope that you all are proud of your hard work.',
        },
        {
            id: 2,
            photo: Tagle,
            name: 'Felipe Tagle',
            position: 'A3 Electric Mobility',
            title: 'Amazing conference! The talks in senior track are really helpful and timely. I learned a lot and I am excited to try new things on React. Thank you for this wonderful opportunity!',
        },
        {
            id: 3,
            photo: Mughal,
            name: 'Henad Mughal',
            position: 'Nayatel Pvt. Ltd',
            title: 'Watching young and mature developers showcasing cool stuffs they do with python code and chatting with python enthusiasts from all over the world is spectacular.',
        },
        {
            id: 4,
            photo: Huzvarova,
            name: 'Katarina Huzvarova',
            position: 'Senior Test Engineer at GlobalLogic Slovakia',
            title: `I'm really happy to be part of QA world and also very happy that there are so many testers all over the world who joined this event and shared their knowledge. Thank you!!!`,
        },
      ]
    }
  }

  renderReviews(item, i) {
    return (
      <div className="reviews_item" key={`workshops-${i}`}>
        <div className='reviews_item-info_wrap'>
            <div className='reviews_item-info' style={{ backgroundImage: `url(${item.photo})` }}>
                <p className="reviews_item_name">{item.name}</p>
                <p className="reviews_item_position">{item.position}</p>
            </div>
            <div className='reviews_item-content'>
                <p className='reviews_title'>{item.title}</p>
            </div>
        </div>
      </div>
    )
  }

  render() {
      return (
          <div className="reviews">
              <h3>What people say</h3>
              <div className='container reviews_wrap'>
                <div className="review_block">
                  {this.state.reviews.map((item, i) => this.renderReviews(item, i))}
                </div>
              </div> 
          </div>
      )
  }
}